import * as React from 'react'
import { NavigationTabs, NavigationTabsButton } from '@components/navigation-tabs'

type Tab = 'data' | 'agreement' | 'notes' | 'history'

interface Props {
  dataRef: React.RefObject<HTMLElement>
  notesRef: React.RefObject<HTMLElement>
}

export const BenefitProgramAgreementDetailsTabs: React.FC<Props> = ({ dataRef, notesRef }) => {
  const [tab, setTab] = React.useState<Tab>('data')

  const handleTabClick = (tab: Tab) => () => {
    setTab(tab)

    const ref = {
      data: dataRef,
      agreement: dataRef,
      notes: notesRef,
      history: notesRef,
    }[tab]

    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const buttons: NavigationTabsButton[] = [
    {
      title: 'Dane firmy',
      isActive: tab == 'data',
      onClick: handleTabClick('data'),
    },
    {
      title: 'Warunki umowy',
      isActive: tab == 'agreement',
      onClick: handleTabClick('agreement'),
    },
    {
      title: 'Notatki',
      isActive: tab == 'notes',
      onClick: handleTabClick('notes'),
    },
    {
      title: 'Historia zmian',
      isActive: tab == 'history',
      onClick: handleTabClick('history'),
    },
  ]

  return <NavigationTabs className="col-6 pl-0" buttons={buttons} />
}
